'use client'

import React from 'react'
import Link from 'next/link'
import { useTranslation } from 'react-i18next'
import { FeatureTriplet } from '@/components/site/feature-triplet'
import { Reveal } from '@/components/site/reveal'
import { SectionHead } from '@/components/site/section-head'
import { SiteSection } from '@/components/site/section'
import { trackSiteLinkClicked } from '@/lib/analytics'

export function TeamSection() {
  const { t } = useTranslation(['web'])
  return (
    <SiteSection tone="ink" trackingKey="team">
      <Reveal>
        <SectionHead
          tone="ink"
          eyebrow={t('web:meetingNotesPage.team.eyebrow')}
          titleKey="web:meetingNotesPage.team.title"
          lead={t('web:meetingNotesPage.team.lead')}
        />
      </Reveal>
      <Reveal className="mt-(--gap-xl)">
        <FeatureTriplet
          variant="ink"
          // value-list: local — i18n key stems of this section's three cards, not a shared value set
          items={['one', 'two', 'three'].map((id) => ({
            title: t(`web:meetingNotesPage.team.items.${id}Title`),
            description: t(`web:meetingNotesPage.team.items.${id}Desc`),
          }))}
        />
      </Reveal>
      <p className="mt-(--gap-lg) font-mono text-(length:--fs-meta) text-background/74">
        {t('web:meetingNotesPage.team.pricing')}{' '}
        <Link
          href="/pricing"
          onClick={() => trackSiteLinkClicked('team', '/pricing')}
          className="border-b border-inv-line text-background"
        >
          {t('web:meetingNotesPage.team.pricingLink')}
        </Link>
      </p>
    </SiteSection>
  )
}
